// extracted by mini-css-extract-plugin
module.exports = {"attribute":"rZARQ","label":"_2aHOn","value":"_3B04h"};